import {
  Announcement,
  AnnouncementOutlined,
  NotInterested,
  Policy,
  PolicyOutlined,
  Speed,
  SpeedOutlined,
} from "@mui/icons-material";
import AccountBalance from "@mui/icons-material/AccountBalance";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";
import SupervisorAccount from "@mui/icons-material/SupervisorAccount";
import SupervisorAccountOutlined from "@mui/icons-material/SupervisorAccountOutlined";
import { ReactElement } from "react";
import { RouteObject } from "react-router-dom";

import Layout, {
  useBackToSubaccountListItem,
} from "~frontend/components/Layout";
import Redirect from "~frontend/components/Redirect";
import { Banners } from "~frontend/components/banners";
import Bundle from "~frontend/components/icons/Bundle";
import BundleFilled from "~frontend/components/icons/BundleFilled";
import CacheClearingApolloProvider from "~frontend/providers/CacheClearingApolloProvider";

import { ComplianceBundles } from "./compliance-bundles";
import { ComplianceRegistrations } from "./compliance-registrations";
import { TenDlcRegistration } from "./compliance-registrations/ten-dlc/Registration";
import { StaffTollFreeRegistration } from "./compliance-registrations/toll-free/StaffTollFreeRegistration";
import { DoNotContactList } from "./do-not-contact-list";
import RateLimits from "./rate-limits";
import StaffEmails from "./staff-emails";
import Tenants from "./tenants";

export function StaffLayout(): ReactElement {
  return (
    <CacheClearingApolloProvider>
      <Layout
        topBarTitle="Scale to Win Internal Admin"
        topBarLink="/staff/tenants"
        sidebarItems={[
          {
            label: "Tenants",
            path: "/staff/tenants",
            icon: <AccountBalanceOutlined />,
            activeIcon: <AccountBalance />,
          },
          {
            label: "Staff Members",
            path: "/staff/staff-emails",
            icon: <SupervisorAccountOutlined />,
            activeIcon: <SupervisorAccount />,
          },
          {
            label: "Rate Limits",
            path: "/staff/rate-limits",
            icon: <SpeedOutlined />,
            activeIcon: <Speed />,
          },
          {
            label: "Banners",
            path: "/staff/banners",
            icon: <AnnouncementOutlined />,
            activeIcon: <Announcement />,
          },
          {
            label: "Do Not Contact List",
            path: "/staff/do-not-contact-list",
            icon: <NotInterested />,
            activeIcon: <NotInterested />,
          },
          {
            label: "Compliance Bundles",
            path: "/staff/compliance-bundles",
            icon: <Bundle />,
            activeIcon: <BundleFilled />,
          },
          {
            label: "Compliance Registrations",
            path: "/staff/compliance-registrations",
            icon: <PolicyOutlined />,
            activeIcon: <Policy />,
          },
        ]}
        sidebarSecondaryItems={useBackToSubaccountListItem()}
      />
    </CacheClearingApolloProvider>
  );
}

export const staffRoutes: RouteObject[] = [
  {
    index: true,
    element: <Redirect to="/staff/tenants" />,
  },
  {
    path: "tenants",
    element: <Tenants />,
  },
  {
    path: "staff-emails",
    element: <StaffEmails />,
  },
  {
    path: "rate-limits",
    element: <RateLimits />,
  },
  {
    path: "banners",
    element: <Banners />,
  },
  {
    path: "do-not-contact-list",
    element: <DoNotContactList />,
  },
  {
    path: "compliance-bundles",
    element: <ComplianceBundles />,
  },
  {
    path: "compliance-registrations/ten-dlc/:brandRegistrationId/:campaignRegistrationId?",
    element: <TenDlcRegistration />,
  },
  {
    path: "compliance-registrations",
    element: <ComplianceRegistrations />,
  },
  {
    path: "compliance-registrations/toll-free/:tollFreeRegistrationId",
    element: <StaffTollFreeRegistration />,
  },
];
